import ReceiptRulesUpsellSvg from 'ext-ui/svg/illustration/ReceiptRulesUpsellSvg'
import React, { useEffect } from 'react'
import { Helmet } from 'react-helmet'
import { useSelector } from 'react-redux'
import OrgSettingsReceiptVerificationBox from 'src/app/Receipt Rules/OrgSettingsReceiptVerificationBox/OrgSettingsReceiptVerificationBox'
import styles from 'src/app/Receipt Rules/ReceiptRules.style'
import BackgroundPageContent from 'src/components/BackgroundPageContent/BackgroundPageContent'
import NotFoundBackgroundPageContent from 'src/components/NotFoundBackgroundPageContent/NotFoundBackgroundPageContent'
import OrgSettingsReceiptRulesBox from 'src/components/OrgSettingsReceiptRulesBox/OrgSettingsReceiptRulesBox'
import SaasUpgradeOrContent from 'src/feature/SaasUpgradeOrContent/SaasUpgradeOrContent'
import { useBackgroundDispatch } from 'src/hooks'
import { useTranslate } from 'src/localization/Trns'
import { UserFeature } from 'src/models/user.models'
import {
  getOrganization,
  getOrganizationCurrencies,
} from 'src/redux/actions/data/organizations.actions'
import { selectUserListModelFromState } from 'src/redux/selectors/auth.selectors'
import {
  selectOrganizationIdFromRoute,
  selectUserExplicitOrganizationListModelFromState,
} from 'src/redux/selectors/data/organizations.selectors'
import { selectAppName } from 'src/redux/selectors/session.selectors'

const ReceiptRules: React.FC = () => {
  const translate = useTranslate()
  const user = useSelector(selectUserListModelFromState)
  const organization = useSelector(
    selectUserExplicitOrganizationListModelFromState,
  )

  const organizationId = useSelector(selectOrganizationIdFromRoute)
  const appName = useSelector(selectAppName)

  const dispatch = useBackgroundDispatch()

  useEffect(() => {
    dispatch(getOrganization(organizationId, true))
  }, [])

  useEffect(() => {
    if (organization?.currencies === undefined) {
      dispatch(getOrganizationCurrencies(organizationId))
    }
  }, [organization?.currencies])

  const showNewOrgSettings = true
  const Container = showNewOrgSettings ? 'div' : BackgroundPageContent

  if (
    user === undefined ||
    !user.hasOrgBookkeeperPermissions ||
    !organization
  ) {
    return <NotFoundBackgroundPageContent />
  }

  return (
    <>
      <Helmet>
        <title>{`Receipt Rules | ${appName}`}</title>
        <meta name="description" content={`Receipt Rules page of ${appName}`} />
      </Helmet>
      <SaasUpgradeOrContent
        illustration={<ReceiptRulesUpsellSvg />}
        title={translate('Receipt Rules')}
        description={translate(
          'Create receipt rules for expenses that require documentation, send reminders for missing receipts, and enable receipt verification to help detect potentially altered or invalid receipts.',
        )}
        ctaDetailSrc={
          'Upgrade to ${tier} today and improve receipt compliance across your organization.'
        }
        feature={UserFeature.BUSINESS_RULES}
      >
        <Container>
          <div css={styles} className={'ReceiptRules'}>
            <OrgSettingsReceiptRulesBox
              organization={organization}
              user={user}
            />
            <OrgSettingsReceiptVerificationBox
              organization={organization}
              user={user}
            />
          </div>
        </Container>
      </SaasUpgradeOrContent>
    </>
  )
}

export default ReceiptRules
